/** @format */
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';

const _ = require('underscore');

export class SimCardTypeHelper {
    private static list: Array<HeaderCheckBoxSelectListElement> = [
        { name: 'simcard:type.e', value: 1 },
        { name: 'simcard:type.q', value: 2 },
        { name: 'simcard:type.esim', value: 3 },
    ];

    public static getList = (): Array<HeaderCheckBoxSelectListElement> => {
        return SimCardTypeHelper.list;
    };

    public static getName = (id: number): string | null => {
        const obj = _.find(SimCardTypeHelper.list, (st: HeaderCheckBoxSelectListElement) => {
            return st.value === id;
        });
        if (obj) {
            return obj.name;
        }
        return null;
    };
}
